import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldImageComponent } from './field-image.component';
import { CardComponent } from '../../../@theme/components/card/card.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldImageRenderImagePipe } from './field-image-render-image.pipe';


@NgModule({
  declarations: [
    FieldImageComponent,
    FieldImageRenderImagePipe,
  ],
  exports: [
    FieldImageComponent
  ],
  imports: [
    CommonModule,
    CardComponent,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FileUploadModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class FieldImageModule { }
